var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.336,
    height: 14.243,
    viewBox: "0 0 14.336 14.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30543",
    "data-name": "Group 30543",
    transform: "translate(-467.024 -663.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30341",
    "data-name": "Group 30341",
    transform: "translate(467.068 663.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30342",
    "data-name": "Group 30342",
    transform: "translate(0.456 0.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11932",
    "data-name": "Path 11932",
    d: "M3.741,12.842l-2.794.775.739-2.83L11.1,1.373a1.453,1.453,0,1,1,2.055,2.055Z",
    transform: "translate(-0.947 -0.947)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11933",
    "data-name": "Path 11933",
    d: "M14.395,44.126a1.834,1.834,0,0,1,2.522.014l.014.013a1.834,1.834,0,0,0,2.537,0,1.834,1.834,0,0,1,2.537,0",
    transform: "translate(-8.877 -31.663)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x2: 2.055,
    y2: 2.055,
    transform: "translate(0.739 9.839)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.37ab7895c74dab4d8b5d61daf08f4f49.svg";
export { ForwardRef as ReactComponent };